import _classCallCheck from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/createClass";
export var PolygonMaskInline = /*#__PURE__*/function () {
  function PolygonMaskInline() {
    _classCallCheck(this, PolygonMaskInline);

    this.arrangement = "one-per-point";
  }

  _createClass(PolygonMaskInline, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.arrangement !== undefined) {
        this.arrangement = data.arrangement;
      }
    }
  }]);

  return PolygonMaskInline;
}();